import { Chip, Tooltip } from '@material-ui/core'
import { MdiReactIconProps } from 'mdi-react'
import { Fragment, ComponentType } from 'react'

interface ChipWithTooltipProps {
  tooltip: string
  label: string
  size?: 'small' | 'medium'
  bgColor?: string
  color?: string
  Icon?: ComponentType<MdiReactIconProps>
}

const ChipWithTooltip = ({
  tooltip,
  label,
  size,
  color,
  bgColor,
  Icon
}: ChipWithTooltipProps) => (
  <Tooltip title={tooltip}>
    <Chip
      label={
        <Fragment>
          {Icon && <Icon size='16' />}
          {label}
        </Fragment>
      }
      size={size}
      style={{ color, backgroundColor: bgColor }}
    />
  </Tooltip>
)

export default ChipWithTooltip
